module.exports = __webpack_public_path__ + "static/theworkout-3-c0cb5178ad4d0d8863cd00cea4a80bf0.jpg";